<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>公告信息</el-breadcrumb-item>
        <el-breadcrumb-item>公告信息详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div
      class="hx-form-container box-shadow"
      style="width:800px;margin-top:40px;"
    >
      <el-form
        :rules="checkItemParams"
        v-loading="formLoading"
        :model="listParams"
      >
        <el-form-item label="公告标题：">
          {{ listParams.title }}
        </el-form-item>

        <el-form-item label="公告内容：">
          <div v-html="listParams.content"></div>
        </el-form-item>

        <el-form-item label="发布时间：">
          {{ listParams.publishTime }}
        </el-form-item>

        <el-form-item style="padding-bottom: 30px;">
          <el-button
            size="small"
            type="primary"
            v-on:click="dialogVisible = true"
            style="left:50%;margin-left:-28px;position: absolute;"
          >
            删除
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>确定要删除该公告吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          style="background:crimson;border:none"
          v-on:click="deleteItem()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      formLoading: false,
      listParams: {},
      dialogVisible: false
    };
  },
  mounted() {
    this.loadDetailData(this.$route.query.id);
  },
  methods: {
    loadDetailData(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/recuperate/notice/detail?noticeId=" + id,
        methods: "GET"
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            const resData = res.body.data;
            for (const i in resData) {
              this.listParams[i] = resData[i];
            }
          } else {
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    deleteItem: function() {
      this.$http({
        url:
          global.apiUrl +
          "/recuperate/notice/delete?noticeId=" +
          this.$route.query.id,
        method: "POST"
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.$router.push({
              name: "convalescenceNotice"
            });
          } else {

          }
        })
        .catch(err => {

          console.error(err);
        });
    },
    handleClose(done) {
      done();
    }
  }
};
</script>
